import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('downloadView');
const type = createActionType('downloadView');

export const VIEW_DOWNLOAD = type('ViewDownload');

export const PREPARE_DOWNLOAD = apiType('PrepareDownload');

export const DOWNLOAD_VIEW_INITIATED = type('DownloadViewInitiated');

export const DOWNLOAD_VIEW_FAILED = type('DownloadViewFailed');
